/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.12",
    versionName: "0.2.0-nightly.2025.7.12",
    versionChannel: "nightly",
    buildDate: "2025-07-12T00:07:44.501Z",
    commitHash: "0bfa616847dd7f2b1a7cceaf04a163872fda74e6",
};
